import { jsx as _jsx } from "react/jsx-runtime";
import { ToastProvider } from "react-native-toast-notifications";
import BaseToast from "./variations/BaseToast";
const ToastMessageProvider = ({ offsetTop = 0, placement = "top", offsetBottom = 5, duration = 3000, children, }) => {
    return (_jsx(ToastProvider, { placement: placement, duration: process.env?.DETOX_ENV !== "test" ? duration : 10, animationType: "slide-in", animationDuration: 250, offsetTop: offsetTop, offsetBottom: offsetBottom, swipeEnabled: true, renderToast: (toastProps) => _jsx(BaseToast, { ...toastProps }), children: children }));
};
export default ToastMessageProvider;
